import {
  maskPhone,
  maskText,
  maskPhoneNumber,
} from "../helperFunctions/HelperFunction";

const LoadingDialog = ({
  title = "",
  message = "",
  primaryMSG = "",
  secondaryMSG = "",
  tertiaryMSG = "",
  bottomMsg = "",
  footerMSG = "",
  email = "",
  phone = "",
  onClose = null, // optional — only renders the ✕ button if provided
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20">
      <div className="bg-white rounded-md shadow-xl  w-[300px] md:w-[460px] overflow-hidden">
        {/* Header bar — matches camera/mic/speaker confirmation modals */}
        <div className="flex items-center justify-between px-4 py-2 bg-[#E7E9EB] border-b border-[#CCCCCC]">
          <p className="font-medium text-sm text-[#111729]">
            {title ? title : "Information"}
          </p>
          {onClose && (
            <button onClick={onClose} className="text-gray-500">
              ✕
            </button>
          )}
        </div>

        {/* Body */}
        <div className="p-6 flex flex-col items-center text-[#111729]">
          {message && (
            <p className="font-semibold mb-4 text-center">{message}</p>
          )}
          {primaryMSG && (
            <p className="text-sm mb-4 text-center">{primaryMSG}</p>
          )}

          {(email || phone) && (
            <div className="flex flex-col items-center gap-1 mb-4">
              {email && (
                <p className="text-sm text-center">
                  Email:{" "}
                  {maskText(
                    sessionStorage.getItem("login_email") ||
                      sessionStorage.getItem("screenup_email"),
                  )}
                </p>
              )}
              {phone && (
                <p className="text-sm text-center">
                  Phone:{" "}
                  {maskPhoneNumber(sessionStorage.getItem("login_phone"))}
                </p>
              )}
            </div>
          )}

          {secondaryMSG && (
            <p className="text-sm mb-4 text-center">{secondaryMSG}</p>
          )}
          {tertiaryMSG && (
            <p className="text-sm mb-4 text-center">{tertiaryMSG}</p>
          )}

          {/* Spinner — recolored to navy to sit on the white card */}
          <div className="relative w-10 h-10 animate-spin-slow my-2">
            {[...Array(12)].map((_, i) => (
              <span
                key={i}
                className="absolute left-1/2 top-1/2 block w-1 h-2.5 bg-[#111729] rounded animate-spinner-bar"
                style={{
                  transform: `rotate(${i * 30}deg) translate(0, -150%)`,
                  animationDelay: `${i * 0.1}s`,
                }}
              />
            ))}
          </div>

          {bottomMsg && <p className="text-sm mt-4 text-center">{bottomMsg}</p>}
          {footerMSG && (
            <p className="text-xs italic text-gray-500 mt-2 text-center">
              {footerMSG}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingDialog;
